import React from "react";

export const Header = (props) => {
  return (
    <header id="header">
      <div className="intro">
        <div className="overlay">
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-md-offset-2 intro-text">
                <h1>
                  {props.data ? props.data.title : "Loading"}
                  <p>{props.data ? props.data.paragraph : "Loading"}</p>
                  <span></span>
                </h1>
                <span></span>
             <a
                  href="tel:+34650745358"
                  className="btn btn-custom btn-lg"
                >
                  Contáctame
                </a>{" "}
             </div>
              </div>
            </div>
          </div>
        </div>
    </header>
  );
};
